const { BUILD } = process.env

const isBuild = () => {
  return BUILD === 'true'
}

export default isBuild
